module.exports = __webpack_public_path__ + "static/media/Group 1515@3x.40e2323f.png";